module.exports = __webpack_public_path__ + "assets/img/travel-details-airport.196d3e15.png";